import type { ReactElement } from 'react'

import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'

type RowsSkeletonProps = { rows?: number }

export function RowsSkeleton({ rows = 4 }: RowsSkeletonProps): ReactElement {
  return (
    <div className="flex flex-col gap-20" aria-hidden>
      <Skeleton height="40px" radius={8} />
      {Array.from({ length: rows }, (_, row) => (
        <Skeleton key={row} height="52px" radius={8} />
      ))}
    </div>
  )
}
